module.exports = __webpack_public_path__ + "static/media/bannner-dia-amigo-2021.e74958c4.png";